import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const discountsSelector = createSelector(
  (state: AppState) => {
    return state.discounts;
  },
  discounts => discounts
);

export const discountIsLoadingSelector = createSelector(
  discountsSelector,
  discountsState => discountsState.isLoading
);
